import { isBrowser } from "utils/isBrowser"

// This object contains the Urls that we want to redirect on diff page after login
const specificUrls = {
  "/register": "/basket",
  "/us/register": "/basket",
}

export const loginWithRedirect = ({
  isNewFlow,
}: { isNewFlow?: boolean } = {}): string => {
  const loginUrl = isNewFlow ? "/signin" : "/login"
  if (!isBrowser()) {
    return loginUrl
  }

  const currentPath = window.location.pathname
  if (specificUrls[currentPath]) {
    const redirectToPath = specificUrls[currentPath]

    return `${loginUrl}?redirectTo=${encodeURIComponent(redirectToPath)}`
  }

  return `${loginUrl}?redirectTo=${encodeURIComponent(
    `${window.location.pathname}${window.location.search}`
  )}`
}

export const registerWithRedirectToMyMembership = (): string => {
  if (!isBrowser()) {
    return `/register`
  }

  return `/register?redirectTo=${encodeURIComponent("/account/my-membership")}`
}
